import React, { useEffect, useState } from 'react'
import AssetRow, { AssetData } from './AssetRow';
import { publishAsset, updateAsset, getMarketplaceList } from '../../api/marketplace';
import Search from 'antd/es/input/Search';
import DashboardImgs from '../../util/Images';
import { Pagination, PaginationProps } from '../Common/Pagination/Pagination';
import styles from './Dashboard.module.scss';
import { Spin, Checkbox } from 'antd';
import PromoteModal from './PromoteModal';
import ListingTypeModal from './ListingTypeModal';
import TopSectionCharts from './TopSectionCharts';

interface DamAssetListingProps {
  damAssets: AssetData[];
  marketplaceData: any[];
  pageSize: number;
  currentPage: number;
  totalCount: number;
  searchText: string;
  onPageChange: (page: number, size?: number) => void;
  onPageSizeChange: (current: number, size: number) => void;
  onSearchChange: (value: string) => void;
  onRefreshData: () => Promise<void>;
}

function DamAssetListing({ 
  damAssets: propDamAssets,
  marketplaceData: propMarketplaceData,
  pageSize,
  currentPage,
  totalCount,
  searchText,
  onPageChange,
  onPageSizeChange,
  onSearchChange,
  onRefreshData
}: DamAssetListingProps) {
    
    const [selectAll, setSelectAll] = useState(false)
    const [promoteModalOpen, setPromoteModalOpen] = useState(false);
    const [listingModalOpen, setListingModalOpen] = useState(false);
    const [selectedListItem, setSelectedListItem] = useState<any>(null);
    const [damAssets, setDamAssets] = useState<AssetData[]>(propDamAssets) 
    const [marketplaceData, setMarketplaceData] = useState<any[]>(propMarketplaceData);
  const [publishLoading, setPublishLoading] = React.useState<string | null>(null);
  const [unpublishLoading, setUnpublishLoading] = React.useState<string | null>(null)

  // Update local state when props change
  useEffect(() => {
    setDamAssets(propDamAssets);
  }, [propDamAssets]);

  useEffect(() => {
    setMarketplaceData(propMarketplaceData);
  }, [propMarketplaceData]);
    const DeleteItems = (ids: any[]) => {
        console.log('DeleteItems arry', ids)
    }


    // Check if all items are selected
    useEffect(() => {
        if (damAssets.length > 0) {
            const allChecked = damAssets.every(item => item.isChecked)
            setSelectAll(allChecked)
        }
    }, [damAssets])

    // Get selected item Ids Array
    const getSelectedAssetsIdsArr = () => {
        //Filter selected assets & return only the selected IDs as array
        // return assets.filter(asset => asset.isChecked).map(asset => asset.id)
        return damAssets.filter(item => item.isChecked).map(item => item.id)
    }
    const promoteFunc = (data: any) => {
        setSelectedListItem(data)
        setPromoteModalOpen(true)
    }
    const promoModalClose = () => {
        setPromoteModalOpen(false)
    }

      const onPublishClick=async(id:any)=>{
        setPublishLoading(id)
        try {
            const marketplaceItem = marketplaceData.find(item => item.damId === id);
            const response=await publishAsset(marketplaceItem._id)
            // Refetch data after successful publish
            await onRefreshData();
        } catch (error) {
            console.error('Publish error:', error);
        } finally {
            setPublishLoading(null)
        }
    }
      const onUnPublishClick=async(id:any)=>{
        console.log("unpublish clicked", id)
        setUnpublishLoading(id)
        try {
            const marketplaceItem = marketplaceData.find(item => item.damId === id);
            if(marketplaceItem){
                // const response=await unpublishAsset(marketplaceItem._id)
                const response=await updateAsset(marketplaceItem._id,{visibility:"private"})
                // Refetch data after successful unpublish
                await onRefreshData();
            }
        } catch (error) {
            console.error('Unpublish error:', error);
        } finally {
            setUnpublishLoading(null)
        }
    }

    const statusMark = (item: string, marketplaceStatus?: any) => {
        if (item === 'SP_request_for_approval') {
            return 'Approval Pending'
        } else if (item === 'DA_ready_to_execute') {
            return 'Ready for Approval'
        } else if (item === 'DA_published') {
            return 'Published'
        } else if (item === 'DA_verified') {
            return 'Verified'
        } else if (item === 'DA_inactive') {
            return 'Inactive'
        } else if (item === 'SP_ready_to_tokenise') {
            return 'Ready to Publish'
        } else if (item === 'DA_ready_to_publish') {
            return 'Ready to Publish'
        }

        return ''
    }

    // Handle select all
    const handleSelectAll = (checked: boolean) => {
        setSelectAll(checked)
        setDamAssets(prevAssets =>
            prevAssets.map(item => ({ ...item, isChecked: checked }))
        )
    }

    // Handle individual checkbox
    const handleCheckboxChange = (id: string | number, checked: boolean) => {
        let assetsArr = [...damAssets]
        assetsArr = assetsArr.map((item) => item.id === id ? { ...item, isChecked: checked } : item)
        setDamAssets(assetsArr);
    }

    const listTypeFunc = (data: any) => {
        console.log("listing type clicked", data)
        setSelectedListItem(data)
        setListingModalOpen(true)
    }
    const listModalClose = () => {
        setListingModalOpen(false)
    }
    
    const DamAssetsRender = () => {
        return damAssets.length > 0 ? <>
            {damAssets.map((item: any, ind: any) => {
                return <>
                    <AssetRow
                        key={ind}
                        asset={item}
                        onCheckboxChange={handleCheckboxChange}
                        onChangeListingClick={(item) =>
                            listTypeFunc(item)
                        }
                        onViewDetailsClick={() => console.log('onViewDetailsClick Item', item.id)}
                        onPromoteClick={() => promoteFunc(item)}
                        onPublishClick={onPublishClick}
                        onUnPublishClick={onUnPublishClick}
                        publishLoading={publishLoading === item.id}
                        unpublishLoading={unpublishLoading === item.id}
                        onRefreshData={onRefreshData}
                    />

                </>
            })}
            <Pagination
                pageSize={pageSize}
                onShowSizeChange={onPageSizeChange}
                current={currentPage}
                onChange={onPageChange}
                total={totalCount}

            />
        </> : <h2 className={styles.noDataTitle}>No data found</h2>
    }

    


    return (
        <>
            <TopSectionCharts/> 
            <section className={styles.product_listing}>
                <h2>Product in Marketplace</h2>
                <div className={styles.filter_row}>
                    <div className={styles.filter_left}>
                        {/* <Checkbox
                        checked={selectAll} 
                        onChange={(e) => handleSelectAll(e.target.checked)}
                        > Select All  
                        </Checkbox>
                        {getSelectedAssetsIdsArr().length > 0 && <div className={styles.trash_box}><img src={DashboardImgs.trashImg} onClick={() => DeleteItems(getSelectedAssetsIdsArr())} /> ({getSelectedAssetsIdsArr().length} selected)</div>} */}
                    </div>
                    <div className={styles.filter_right}>


                        <Search
                            placeholder="Search digital assets"
                            allowClear
                            enterButton
                            value={searchText}
                            onChange={(e) => {
                                onSearchChange(e.target.value);
                            }}
                            onSearch={(value) => {
                                onSearchChange(value);
                            }}
                            style={{ maxWidth: 300, marginBottom: 16 }}
                        />
                    </div>


                </div>

                <DamAssetsRender />

            </section>

            <PromoteModal open={promoteModalOpen} itemDetails={selectedListItem} closeModal={promoModalClose} onRefreshData={onRefreshData} />
            <ListingTypeModal open={listingModalOpen} itemDetails={selectedListItem} closeModal={listModalClose} onUpdateSuccess={onRefreshData} /> 

      
        </>
        
        
    )
}

export default DamAssetListing